<input matInput [id]="id" [type]="to.type || 'text'" [formControl]="$any(field)?.formControl" [formlyAttributes]="field"
    [mask]="to.mask" [prefix]="to.prefix?to.prefix:''" [thousandSeparator]=" to?.thousandSeparator"
    [minlength]="to.minLength" [maxlength]="to.maxLength">